import type { TextProps } from "react-aria-components";
import { tv } from "tailwind-variants";

import { Heading, type HeadingProps } from "@/components/ui/heading";
import { Loader } from "@/components/ui/loader";
import { Text } from "@/components/ui/text";

const emptyStateStyles = tv({
  slots: {
    root: "flex h-full w-full flex-1 flex-col items-center justify-center gap-1 p-4 text-center @container",
    icon: [
      "flex max-w-32 items-center justify-center @md:max-w-40",
      "[&>svg:not([class*=text-])]:text-muted-foreground [&>svg]:h-auto [&>svg]:min-w-6 [&>svg]:max-w-full",
    ],
    heading: "text-balance",
    description: "max-w-prose text-balance",
    actions: "mt-3 flex flex-col items-center justify-center gap-4 p-2",
  },
});

const { root, icon, heading, description, actions } = emptyStateStyles();

export function EmptyState({
  className,
  isLoading,
  ...props
}: React.ComponentProps<"div"> & { isLoading?: boolean }) {
  return isLoading ? (
    <Loader />
  ) : (
    <div {...props} className={root({ className })} />
  );
}

export function EmptyStateIcon({
  className,
  children,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div {...props} className={icon({ className })}>
      {children}
    </div>
  );
}

export function EmptyStateHeading({
  className,
  level = 3,
  ...props
}: HeadingProps) {
  return (
    <Heading {...props} level={level} className={heading({ className })} />
  );
}

export function EmptyStateDescription({ className, ...props }: TextProps) {
  return <Text {...props} muted className={description({ className })} />;
}

export function EmptyStateActions({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div {...props} className={actions({ className })} />;
}
